import { defineAsyncComponent } from 'vue';
import collectionsConfig from './collections.config';

export interface IDynamicComponentConfig {
  component: object;
  fields?: Array<string | object>;
  props?: object;
  noData?: boolean;
}

// articles content

const contentButtons: IDynamicComponentConfig = {
  component: defineAsyncComponent(() => import('~/components/content/Buttons.vue')),
  fields: collectionsConfig.contentButtons,
};

const contentEmbeds: IDynamicComponentConfig = {
  component: defineAsyncComponent(() => import('~/components/content/Embeds.vue')),
  fields: collectionsConfig.contentEmbeds,
  noData: true,
};

const contentImages: IDynamicComponentConfig = {
  component: defineAsyncComponent(() => import('~/components/content/Images.vue')),
  noData: true,
};

const contentCarousels: IDynamicComponentConfig = {
  component: defineAsyncComponent(() => import('~/components/content/Carousels.vue')),
  fields: collectionsConfig.contentCarousels,
  props: {
    autoplay: false,
  },
};

const contentNewsletters: IDynamicComponentConfig = {
  component: defineAsyncComponent(() => import('~/components/content/Newsletters.vue')),
  fields: collectionsConfig.contentNewsletters,
};

const contentQuotes: IDynamicComponentConfig = {
  component: defineAsyncComponent(() => import('~/components/content/Quotes.vue')),
  fields: collectionsConfig.contentQuotes,
};

const contentTeasers: IDynamicComponentConfig = {
  component: defineAsyncComponent(() => import('~/components/content/Teasers.vue')),
  fields: collectionsConfig.contentTeasers,
};

const contentTexts: IDynamicComponentConfig = {
  component: defineAsyncComponent(() => import('~/components/content/Texts.vue')),
  noData: true,
};

const contentInfoBlocks: IDynamicComponentConfig = {
  component: defineAsyncComponent(() => import('~/components/content/InfoBlocks.vue')),
  fields: collectionsConfig.contentInfoBlocks,
};

const contentParticipationBlocks: IDynamicComponentConfig = {
  component: defineAsyncComponent(() => import('~/components/content/ParticipationBlocks.vue')),
  fields: collectionsConfig.contentParticipationBlocks,
};

const contentFoldOutBlocks: IDynamicComponentConfig = {
  component: defineAsyncComponent(() => import('~/components/content/FoldOutBlocks.vue')),
  fields: collectionsConfig.contentFoldOutBlocks,
};

const contentChats: IDynamicComponentConfig = {
  component: defineAsyncComponent(() => import('~/components/content/Chats.vue')),
  noData: true,
};

// dossiers

const contentLabeledTeasers: IDynamicComponentConfig = {
  component: defineAsyncComponent(() => import('~/components/content/LabeledTeasers.vue')),
  noData: true,
};

// sections

const sectionCarousel: IDynamicComponentConfig = {
  component: defineAsyncComponent(() => import('~/components/section/Carousel.vue')),
  fields: collectionsConfig.sectionCarousel,
};

const sectionDossiers: IDynamicComponentConfig = {
  component: defineAsyncComponent(() => import('~/components/section/Dossiers.vue')),
  fields: collectionsConfig.sectionDossiers,
};

const sectionGrid: IDynamicComponentConfig = {
  component: defineAsyncComponent(() => import('~/components/section/Grid.vue')),
  fields: collectionsConfig.sectionGrid,
};

const sectionMostRead: IDynamicComponentConfig = {
  component: defineAsyncComponent(() => import('~/components/section/MostRead.vue')),
  noData: true,
};

const sectionShorts: IDynamicComponentConfig = {
  component: defineAsyncComponent(() => import('~/components/section/Shorts.vue')),
  fields: collectionsConfig.sectionShorts,
};

const sectionArticleShorts: IDynamicComponentConfig = {
  component: defineAsyncComponent(() => import('~/components/section/ArticleShorts.vue')),
  fields: collectionsConfig.sectionArticleShorts,
};

const sectionSpotlight: IDynamicComponentConfig = {
  component: defineAsyncComponent(() => import('~/components/section/Spotlight.vue')),
  fields: collectionsConfig.sectionSpotlight,
};

const sectionEditorialTips: IDynamicComponentConfig = {
  component: defineAsyncComponent(() => import('~/components/section/EditorialTips.vue')),
  fields: collectionsConfig.sectionEditorialTips,
};

export default {
  // articles content
  contentButtons,
  contentEmbeds,
  contentImages,
  contentCarousels,
  contentNewsletters,
  contentQuotes,
  contentTeasers,
  contentTexts,
  contentParticipationBlocks,
  contentInfoBlocks,
  contentFoldOutBlocks,
  contentChats,

  // dossiers
  contentLabeledTeasers,

  // sections
  sectionCarousel,
  sectionDossiers,
  sectionGrid,
  sectionMostRead,
  sectionShorts,
  sectionArticleShorts,
  sectionSpotlight,
  sectionEditorialTips,
};
